import "./ChoiceInput.scss"

import React, { FunctionComponent, ReactNode } from "react"
import cx from "classnames"

type ChoiceInputValue = React.InputHTMLAttributes<HTMLInputElement>["value"]

export enum ChoiceInputType {
    radio = "radio",
    checkbox = "checkbox"
}

export interface IChoiceInputProps {
    type: ChoiceInputType
    label?: ReactNode
    name?: string
    value?: ChoiceInputValue
    checked?: boolean
    partiallyChecked?: boolean
    disabled?: boolean
    testId?: string
    onChange?(value?: ChoiceInputValue): void
}

const ChoiceInput: FunctionComponent<React.PropsWithChildren<IChoiceInputProps>> = ({
    type,
    label,
    name,
    value,
    checked,
    partiallyChecked,
    disabled,
    testId,
    onChange
}) => {
    function handleChange() {
        if (typeof onChange !== "function") return
        onChange(value)
    }

    const rootClassNames = cx([
        "choice-input",
        `choice-input--${type}`,
        {
            "choice-input--disabled": disabled,
            "choice-input--checked": checked && !partiallyChecked,
            "choice-input--partially-checked": partiallyChecked && !checked,
            "choice-input--no-label": !label,
        }
    ])

    return (
        <label className={rootClassNames}>
            <input type={type}
                className="choice-input__input"
                disabled={disabled}
                name={name}
                value={value}
                onChange={handleChange}
                checked={checked}
                data-testid={testId}
            />
            {!!label &&
                <span className="choice-input__label">
                    {label}
                </span>
            }
        </label>
    )
}

export default ChoiceInput
